import { Add, ContactPhoneRounded, Inventory, MonitorHeart, People, FileUpload, Description } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { useGetOrganizationQuery } from '../../../api/apiSlice';
import LoadingIndicator from '../../LoadingIndicator';
import OrganizationConfiguration from './OrganizationConfiguration';

function OrganizationView() {
    const params = useParams();
    const navigate = useNavigate();
    const { data: organizationData, isLoading, isSuccess } = useGetOrganizationQuery(params.organizationId);

    function handleClick() {
        navigate('/superSettings/hospitals/create', { state: { organizationId: organizationData.id, organizationName: organizationData.name } });
    }

    return (
        isLoading && <LoadingIndicator /> ||
        !isLoading && isSuccess &&
        <Stack pl={4} spacing={4}>
            <Typography variant='heavy' sx={{ fontSize: '24px', marginTop: '20px' }}>
                <strong>Organization Details</strong>
            </Typography>
            <Stack direction='row' spacing={4}>
                <OrganizationConfiguration organization={organizationData} key={organizationData.id} />
                <Stack justifyContent='left' alignItems='left' spacing={2} p={4} boxShadow={2} backgroundColor='white' borderRadius='8px'>
                    <Typography variant='heavy' fontSize='20px'>Manage Organization</Typography>
                    <Button
                        variant='text'
                        startIcon={<Add />}
                        onClick={() => handleClick()}
                    >
                        Create New Hospital
                    </Button>
                    <Button variant='text' startIcon={<People />} onClick={() => navigate(`/superSettings/organizations/${params.organizationId}/physicians`)}>Manage Physicians</Button>
                    <Button variant='text' startIcon={<People />} onClick={() => navigate(`/superSettings/organizations/${params.organizationId}/users`)}>Manage Users</Button>
                    <Button variant='text' startIcon={<ContactPhoneRounded />} onClick={() => navigate(`/superSettings/organizations/${params.organizationId}/physicianContacts`)}>Manage Physician Contacts</Button>
                    <Button variant='text' startIcon={<MonitorHeart />} onClick={() => navigate(`/superSettings/organizations/${params.organizationId}/recommendationBatches`)}>Recommendation Batch Tracking</Button>
                    <Button variant='text' startIcon={<Inventory />} onClick={() => navigate(`/superSettings/organizations/${params.organizationId}/packs`)}>Pack Management</Button>
                    <Button variant='text' startIcon={<FileUpload />} onClick={() => navigate(`/superSettings/organizations/${params.organizationId}/manualUpload`)}>Manually Upload Source File</Button>
                    <Button variant='text' startIcon={<Description />} onClick={() => navigate(`/superSettings/organizations/${params.organizationId}/uncategorizedItemsReport`)}>Generate Uncategorized Items Report</Button>
                </Stack>
            </Stack>
        </Stack>
    );
}

export default OrganizationView;